import i18n from '@/i18n'

i18n.mergeLocaleMessage('en', {
	'optimize_image' : {
        'name': 'Actual Speed',
        'optimize_history': 'Optimization History',
        'dont_make_customer_wait': 'Don’t make your customers wait',
        'description': 'Actual Speed is how fast your pages loads. Optimize images and theme to boost Actual Speed..',
        'theme_optimization': 'Theme optimization',
        'image_optimization': 'Image Optimization',
        'theme_unpublish': 'Updates are unpublished',
        'preview_publish': 'Please preview theme to make sure everything looks fine then publish theses updates.',
        'remove_theme': 'Removing theme changes...',
        'publish_theme': 'Publishing your theme...',
        'remove_theme_description': 'It usually takes 2-5 minutes to remove',
        'publish_theme_description': 'It usually takes 2-5 minutes to publish',
        'view_detail': 'View details',
        'select_all_images': 'Select all images',
        'unselect_all_images': 'Unselect all images',
        'publish_tooltip': 'Please preview the change to make sure everything is working well before publishing',
        'buttons': {
            'preview': 'Preview',
            'publish': 'Publish',
            'remove_anyway': 'Remove duplicate theme',
            'optimize_now': 'Optimize now',
            'buy_more_images': 'Buy more images',
            'optimize_theme_only' : 'Optimize theme only',
            'later': 'Later',
            'set_up_optimization': 'Set up optimization',
            'remove_our_code': 'Remove our code',
            'contact_support': 'Contact our support',
            'auto_optimize': 'Auto optimize',
            'restore': 'Restore',
            'yes_look_good': 'Yes, it looks good',
            'no_broken': 'No, it is broke somehow'
        },
        'modal_optimization_methods': {
            'title': 'Select your method',
            'description': 'Recommend choose both methods to get your store to peak performance.',
            'scanning_images': 'Scanning images',
            'scanning_description': 'Getting all images info. About <1 minute remaining...',
        },
        'modal_optimization_result': {
            'title': 'Optimization in progress',
            'onboarding_description': 'Swift is optimizing your images and themes. You can explore<br> other functions while waiting for the progress finishes',
            'app_description': 'Your optimization will finish in a few minutes. You can<br> track your progress everywhere in app',
            'onboarding_btn': 'Go to dashboard',
            'got_it': 'Got it'
        },
        'notification_bar': {
            'image': {
                'title': 'Optimization Needed',
                'content': 'Optimize <strong>{images} images</strong> to save up to <strong>{number}</strong>',
            },
            'theme': {
                'title': 'Your theme has change',
                'content': 'Please optimize to speed up your new theme',
                'new_theme_description': 'We noticed you changed your theme recently! <br>Please optimize to speed up your new theme'
            },
            'all': {
                'title': 'Optimization Needed',
                'content': 'Optimize <strong>{images} images</strong> and your <strong>new theme</strong> to speed up your store',
            }
        },
        'optimization_result': {
            'summary': {
                'title': 'Process Completed',
            },
            'needed': {
                'title': 'Optimization needed'
            },
            'image': {
                'summary_btn_ok': 'View details',
                'summary_btn_cancel': 'Later',
                'needed_btn_ok': 'Optimize now',
                'needed_btn_cancel': 'Later',
            },
            'theme': {
                'summary_btn_ok': 'Preview now',
                'summary_btn_cancel': 'Later',
                'needed_btn_ok': 'Optimize now',
                'needed_btn_cancel': 'Later',
            },
            'all': {
                'summary_btn_ok': 'Preview now',
                'summary_btn_cancel': 'Later',
                'needed_btn_ok': 'Optimize now',
                'needed_btn_cancel': 'Later',
            }

        },
        'modal_preview_img': {
            'title': 'Preview Image',
            'original_size': 'Original Size',
            'optimized_size': 'Optimized Size',
        },
        'modal_restore_img': {
            'title': 'Restore image?',
            'description': 'You won’t be able to undo this action. <br/> Your image usage will remain the same.',
            'checkbox_text': "Don't show this again",
            'btn_text': 'Restore anyway'
        },
        'restore_success': {
            'title': 'Restore Successfully',
            'message': 'Your images just restored'
        },
        'errors': {
            'all_image_optimized': 'All images have optimized',
            'no_images_found': 'No new images found',
            'no_theme_found': 'No new theme found',
            'all_theme_optimized': 'Your theme has optimized',
            'no_codes_found': 'No new codes found',
            'image_not_found': 'Image not found',
            'some_seleted_images_not_found': 'Some of selected images not found',
            'image_deleted': 'Your image may delete'
        },
        'components': {
            'stop_optimize_theme': 'Stop optimizing theme?',
            'stop_optimize_image': 'Stop optimizing images?',
            'stop_optimize_image_desc': 'Optimized images will still remain and included in your image usage',
            'optimizing_theme': 'Optimizing theme...',
            'optimizing_image': 'Optimizing images...',
            'lazyload': 'Lazyload Image',
            'minify_css': 'Minify CSS',
            'preload_font': 'Preload Fonts',
            'minify_js': 'Minify JS',
            'critical_css': 'Critical CSS',
            'trouble_with_theme': 'I have a trouble with theme!',
            'trouble_with_theme_description': "Don't worry, you can contact our support for help or remove our code.",
            'auto_optimization': 'Auto optimization',
            'optimize_images': 'Optimize images',
            'optimize_theme': 'Optimize theme',
            'daily_scanning': '<span class="primary-color fw-600">Daily</span> scanning and optimizing',
            'weekly_scanning': '<span class="primary-color fw-600">Weekly</span> scanning and optimizing',
            'description_publish_theme': 'We use your lastest method you have published to publish into your active theme',
            'keep_your_store': 'Keep your store always updated',
            'auto_banner_description': 'Set up Auto Optimize for your store here. It helps you keep your store always optimized.',
            'optimization_started': 'Optimization will be started at',
            'publish_success_title': 'Does the publish theme work well?'
		},
        'modal_publish_theme': {
            'content': 'Does your store look fine after optimizing?',
            'publish_now': 'Good, publish now',
            'need_help': 'Bad, I need help',
        },
        'modal_remove_theme': {
            'title': 'Remove duplicate theme',
            'content': 'Changes applied to your duplicated theme will be removed.<br>Are you sure to remove them?',
            'remove': 'Remove'
        },
        'modal_trouble_theme': {
            'content': 'I have trouble with theme.',
            'remove_theme': 'Remove theme changes',
            'contact': 'Contact for help'
        },
        'save_auto_settings': {
            'title_toast_success': 'Save changed',
            'content_toast_success': 'Your setting is saved',
            'title_toast_error': 'Save error',
            'content_toast_error': 'Your setting cannot save'
        },
        'restore_disable': 'Images can not be restored after 2 weeks. <a class="a-link fz-14" href="{link}" target="_blank">Learn more</a>'
    }
})
